import { useParams, Navigate } from 'react-router-dom';
import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import VideoPlayer from './components/VideoPlayer';
import VideoInfo from './components/VideoInfo';
import RelatedVideos from './components/RelatedVideos';
import { videos } from '@/mocks/videos';

export default function VideoPage() {
  const { id } = useParams<{ id: string }>();
  const video = videos.find((v) => v.id === Number(id));

  useEffect(() => {
    if (video) {
      document.title = `${video.title} - 吃瓜视频 | 独家吃瓜爆料`;
      const metaDesc = document.querySelector('meta[name="description"]');
      if (metaDesc) {
        metaDesc.setAttribute(
          'content',
          `${video.title}。${video.description.slice(0, 120)} 每日更新网红翻车、明星八卦、免费吃瓜视频下载观看。`
        );
      }
    }
  }, [video]);

  if (!video) {
    return <Navigate to="/" replace />;
  }

  return (
    <>
      <Navbar />
      <main>
        <article className="w-full pt-20 pb-14 md:pt-24 md:pb-16 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex flex-col lg:flex-row gap-8 lg:gap-10">
              <div className="flex-1 lg:max-w-[60%]">
                <VideoPlayer
                  thumbnail={video.thumbnail}
                  title={video.title}
                  duration={video.duration}
                />
              </div>
              <div className="flex-1 lg:max-w-[40%]">
                <VideoInfo
                  title={video.title}
                  description={video.description}
                  views={video.views}
                  date={video.date}
                  duration={video.duration}
                  category={video.category}
                  tags={video.tags}
                  source={video.source}
                />
              </div>
            </div>
          </div>
        </article>

        <RelatedVideos currentId={video.id} category={video.category} />
      </main>
      <Footer />
    </>
  );
}